import { render, staticRenderFns } from "./Create-Center.vue?vue&type=template&id=433b2d10"
import script from "./Create-Center.vue?vue&type=script&lang=js"
export * from "./Create-Center.vue?vue&type=script&lang=js"
import style0 from "./Create-Center.vue?vue&type=style&index=0&id=433b2d10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports